import { createIcon } from './create-icon'

export const EditAlt = createIcon({
  displayName: 'EditAlt',
  paths: [
    'M355.121 735.829c-0.896 0-1.792-0.341-2.475-1.024l-55.381-55.381c-1.365-1.365-1.365-3.584 0-4.949l417.406-417.451c0.683-0.683 1.579-1.024 2.475-1.024s1.792 0.341 2.475 1.024l55.381 55.424c1.408 1.323 1.408 3.541 0 4.907l-417.406 417.451c-0.683 0.683-1.579 1.024-2.475 1.024zM717.146 170.667c-22.699 0-45.483 8.704-62.805 26.027l-419.326 419.328c-0.384 0.384-0.683 0.853-0.811 1.365l-61.099 183.168c-10.325 31.061 13.653 60.8 43.563 60.8 4.821 0 9.813-0.768 14.848-2.432l183.168-61.056c0.512-0.171 0.981-0.469 1.365-0.811l419.326-419.371c34.688-34.688 34.688-90.88 0-125.611l-55.381-55.381c-17.365-17.323-40.107-26.027-62.848-26.027z'
  ]
})
